// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB03cZwKu07MHfTat2CHSSLhpVtezJ0s7g",
    authDomain: "pickeasy-app.firebaseapp.com",
    databaseURL: "https://pickeasy-app.firebaseio.com",
    projectId: "pickeasy-app",
    storageBucket: "pickeasy-app.appspot.com",
    messagingSenderId: "331541131061",
    appId: "1:331541131061:web:47682e96002f84150be67c",
    measurementId: "G-B5WWZY7C1M"
  },
  apiBaseUrl: 'https://production.api.pickeasy.ca/',
  // apiBaseUrl: 'http://192.168.2.60:5000/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
